/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from '../transformer';
import Picture from '../common/picture';

export default class MyStudents extends Transformer {
  /**
   * Method used to transform a jobs to full-calendar representation
   *
   * @param student Student
   *
   * @returns {Object} The transformed account
   */
  static fetch(student) {
    return {
      id: student.id,
      firstName: student.first_name,
      lastName: student.last_name,
      shortName: student.short_name,
      gender: student.gender,
      phone: student.phone,
      geoPools: student.geo_pools,
      mainPicture: student.main_picture ? student.main_picture : null,
      pictureHostess: student.picture_hostess ? Picture.fetch(student.picture_hostess) : null,
      pictureHostessFull:
        student.picture_hostess_full
          ? Picture.fetch(student.picture_hostess_full) : null,
      birthdayDate: student.birthday_date,
      feedbackScoreForCurrentCustomer: student.feedback_score_for_current_customer,
      jobCountForCurrentCustomer: student.job_count_for_current_customer,
      lastJobDateForCurrentCustomer: student.last_job_date_for_current_customer,
    };
  }
}
